// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"389f5261","187":"3cfbfefd","446":"eb42c0d5","453":"d59ecee0","640":"2b99b44c","671":"57d69e78","809":"0a0083d3","835":"31058874"}[chunkId] + ".chunk.js";
};